import { render, staticRenderFns } from "./StartRegistration.vue?vue&type=template&id=b8f2a698&"
import script from "./StartRegistration.vue?vue&type=script&lang=ts&"
export * from "./StartRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports